import { fuego } from '@nandorojo/swr-firestore';

interface InextPrevPage {
  collectionPath: string;
  currentDocId: string;
  orderBy?: string;
  offset?: number;
  limit?: number;
}

// gallery detail use now
export async function nextPage({
  collectionPath,
  currentDocId,
  orderBy,
  offset,
  limit = 1,
}: InextPrevPage) {
  const ref = fuego.db.collection(collectionPath);
  const snapshot = await ref.doc(currentDocId).get();

  return ref
    .orderBy(orderBy || 'createdAt', 'desc')
    .limit(limit)
    .startAfter(snapshot)
    .get()
    .then((d) => {
      const docs: any = [];
      d.docs.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id, __snapshot: doc });
      });
      return docs[0];
    });
}

// gallery detail use now
export async function prevPage({
  collectionPath,
  currentDocId,
  orderBy,
  offset,
  limit = 1,
}: InextPrevPage) {
  const ref = fuego.db.collection(collectionPath);
  const snapshot = await ref.doc(currentDocId).get();

  return ref
    .orderBy(orderBy || 'createdAt', 'desc')
    .endBefore(snapshot)
    .limitToLast(limit)
    .get()
    .then((d) => {
      const docs: any = [];
      d.docs.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id, __snapshot: doc });
      });
      return docs[0];
    });
}

// infinite paginate
interface paginateProps {
  list: any;
  collectionPath: string;
  limit: number;
  orderBy?: string;
  mutate: any;
  offset?: number;
  hashtags?: string[];
  selectedHashtag?: string;
}

export const infinitePaginate = async ({
  list,
  collectionPath,
  limit,
  orderBy = 'createdAt',
  mutate,
  offset,
}: paginateProps) => {
  if (!list?.length) return;
  const ref = fuego.db.collection(collectionPath);

  let queryRef = ref.orderBy(`${orderBy}`, 'desc').limit(limit);
  if (list?.length) {
    const startAfterDocument = list[list.length - 1].__snapshot;
    if (!startAfterDocument) {
      console.error('startAfterDocument is undefined. Skipping query.');
      return;
    }
    queryRef = queryRef.startAfter(startAfterDocument);
  }

  return queryRef.onSnapshot(
    (snapshot) => {
      const docs: any = [];
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added' || change.type === 'modified') {
          docs.push({
            ...change.doc.data(),
            id: change.doc.id,
            __snapshot: change.doc,
          });
        }
      });

      if (docs.length > 0) {
        mutate((state) => {
          const existingIds = new Set(state.map((item) => item.id));
          const filteredDocs = docs.filter((doc) => !existingIds.has(doc.id));
          return [...state, ...filteredDocs];
        }, false);
      }
    },
    (error) => {
      console.error('Error fetching documents: ', error);
    },
  );
};

export const infiniteLastPaginate = async ({
  currentDocId,
  collectionPath,
  limit,
  mutate,
}: any) => {
  const ref = fuego.db.collection(collectionPath);
  const startAfterDocument = await ref.doc(currentDocId).get();

  // get the snapshot of last document we have right now in our query
  const moreDocs = await ref
    .orderBy('createdAt', 'desc')
    .startAfter(startAfterDocument)
    .limit(limit)
    .get()
    .then((d) => {
      const docs: any = [];
      d.docs.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id, __snapshot: doc });
      });
      return docs;
    });
  // get more documents, after the most recent one we have

  // mutate our local cache, adding the docs we just added
  // set revalidate to false to prevent SWR from revalidating on its own

  mutate((state) => [...state, ...moreDocs], false);
};
